import { render } from "./AdProvider.vue?vue&type=template&id=0d864ce5&scoped=true"
import script from "./AdProvider.vue?vue&type=script&lang=js"
export * from "./AdProvider.vue?vue&type=script&lang=js"

import "./AdProvider.vue?vue&type=style&index=0&id=0d864ce5&scoped=true&lang=css"
import "./AdProvider.vue?vue&type=style&index=1&id=0d864ce5&scoped=true&lang=css"
import "./AdProvider.vue?vue&type=style&index=2&id=0d864ce5&scoped=true&lang=css"
import "./AdProvider.vue?vue&type=style&index=3&id=0d864ce5&scoped=true&lang=css"
import "./AdProvider.vue?vue&type=style&index=4&id=0d864ce5&scoped=true&lang=css"
import "./AdProvider.vue?vue&type=style&index=5&id=0d864ce5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d864ce5"],['__file',"src/views/report/AdProvider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d864ce5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d864ce5', __exports__)) {
    api.reload('0d864ce5', __exports__)
  }
  
  module.hot.accept("./AdProvider.vue?vue&type=template&id=0d864ce5&scoped=true", () => {
    api.rerender('0d864ce5', render)
  })

}


export default __exports__